/**
 *
 * @param target
 * @param blacklist
 *
 * @return {{}|void}
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
      typeof Symbol === "function" &&
      obj.constructor === Symbol &&
      obj !== Symbol.prototype
          ? "symbol"
          : typeof obj;
    };
  }
  return _typeof(obj);
}

var _underscore = function _underscore(target) {
  var blacklist =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var keys = Object.keys(target) || [];
  var transformedObject = {};
  if (!keys.length) return; // Loop through all object keys

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (
        var _iterator = keys[Symbol.iterator](), _step;
        !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
        _iteratorNormalCompletion = true
    ) {
      var key = _step.value;
      var keyClone = key; // Skip this key

      if (blacklist.includes(key)) {
        continue;
      } // Nothing to transform

      if (key.includes("_")) {
        Reflect.set(transformedObject, key, target[key]);
        continue;
      } // Loop through every character of this key to check if it contains any uppercase characters

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (
            var _iterator2 = key[Symbol.iterator](), _step2;
            !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done);
            _iteratorNormalCompletion2 = true
        ) {
          var character = _step2.value;
          if (character !== character.toUpperCase()) continue;
          keyClone = keyClone.replace(
              character,
              "_".concat(character.toLowerCase())
          );
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      Reflect.set(transformedObject, keyClone, target[key]); // Deep naming transformer

      if (
          _typeof(transformedObject[keyClone]) === "object" &&
          !Array.isArray(transformedObject[keyClone])
      ) {
        Reflect.set(
            transformedObject,
            keyClone,
            _underscore(transformedObject[keyClone])
        );
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return transformedObject;
};

module.exports = { _underscore }
